import { render, staticRenderFns } from "./BasicMailDriver.vue?vue&type=template&id=703cfaaa&"
import script from "./BasicMailDriver.vue?vue&type=script&lang=js&"
export * from "./BasicMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703cfaaa')) {
      api.createRecord('703cfaaa', component.options)
    } else {
      api.reload('703cfaaa', component.options)
    }
    module.hot.accept("./BasicMailDriver.vue?vue&type=template&id=703cfaaa&", function () {
      api.rerender('703cfaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/mail-driver/BasicMailDriver.vue"
export default component.exports